import React, { useRef } from "react";

// Same letterforms as logo6.svg — kept as separate paths so each glyph can
// slide independently during the sales-to-profit animation.
const LETTERS = [
  {
    transform: "translate(89 72)",
    d: "M0 0 C2.86267567 -0.07325168 5.700719 -0.09238205 8.5625 -0.0625 C9.36880859 -0.05798828 10.17511719 -0.05347656 11.00585938 -0.04882812 C13.00393756 -0.03700518 15.00197783 -0.01906914 17 0 C22.98972809 12.55057707 28.3231946 25.38708253 33.75 38.1875 C35.79718676 43.01083757 37.84558556 47.83365938 39.89453125 52.65625 C40.40641495 53.86145798 40.91829865 55.06666595 41.44569397 56.30839539 C44.77646251 64.14339692 48.13359259 71.96656076 51.51171875 79.78125 C52.35515459 81.73542804 53.1985794 83.68961084 54.04199219 85.64379883 C55.23157895 88.39937489 56.42296824 91.15409488 57.62023926 93.90634155 C58.70852262 96.40822863 59.79042381 98.91278595 60.87109375 101.41796875 C61.19180344 102.14975342 61.51251312 102.88153809 61.84294128 103.63549805 C63.1127196 106.59258867 64 108.74569283 64 112 C58.39 112 52.78 112 47 112 C42.38 100.78 37.76 89.56 33 78 C20.79 77.67 8.58 77.34 -4 77 C-2.68 73.04 -1.36 69.08 0 65 C9.24 65 18.48 65 28 65 C26.535625 61.65875 25.07125 58.3175 23.5625 54.875 C19.92736513 46.53006823 16.35155055 38.16230681 12.875 29.75 C12.48513916 28.81655762 12.09527832 27.88311523 11.69360352 26.92138672 C11.33838623 26.05529785 10.98316895 25.18920898 10.6171875 24.296875 C10.30378418 23.53729492 9.99038086 22.77771484 9.66748047 21.99511719 C9 20 9 20 9 17 C8.34 17 7.68 17 7 17 C6.78718384 17.81198853 6.78718384 17.81198853 6.57006836 18.64038086 C4.47496978 26.12987953 1.53677397 33.2027904 -1.49655151 40.3458252 C-3.15510614 44.25302766 -4.79579286 48.16772672 -6.4375 52.08203125 C-6.79271225 52.92812958 -7.1479245 53.77422791 -7.51390076 54.64596558 C-12.40270511 66.31398601 -17.16458921 78.03422718 -21.9375 89.75 C-22.38954803 90.85908722 -22.84159607 91.96817444 -23.30734253 93.11087036 C-25.87334132 99.40652331 -28.43754671 105.70290317 -31 112 C-36.28 112 -41.56 112 -47 112 C-44.57264521 104.28035125 -41.5315346 96.88336926 -38.375 89.4375 C-37.80640324 88.0892928 -37.23805087 86.74098251 -36.66992188 85.39257812 C-31.25533129 72.55479446 -25.79515739 59.73612678 -20.33544922 46.91748047 C-16.88816343 38.82037869 -13.45404494 30.71828584 -10.0625 22.59765625 C-9.60345276 21.49905777 -9.60345276 21.49905777 -9.13513184 20.37826538 C-7.70159393 16.94577082 -6.27132283 13.51196246 -4.84570312 10.07617188 C-4.35005859 8.88701172 -3.85441406 7.69785156 -3.34375 6.47265625 C-2.69696289 4.91430054 -2.69696289 4.91430054 -2.03710938 3.32446289 C-1 1 -1 1 0 0 Z",
  },
  {
    transform: "translate(169 72)",
    d: "M0 0 C28.38 0 56.76 0 86 0 C86 3.96 86 7.92 86 12 C74.45 12 62.9 12 51 12 C51 45 51 78 51 112 C45.72 112 40.44 112 35 112 C35 79 35 46 35 12 C23.45 12 11.9 12 0 12 C0 8.04 0 4.08 0 0 Z",
  },
  {
    transform: "translate(284 72)",
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 36.96 16 73.92 16 112 C10.72 112 5.44 112 0 112 C0 75.04 0 38.08 0 0 Z",
  },
  {
    transform: "translate(423 75)",
    d: "M0 0 C0.495 0.495 0.495 0.495 1 1 C1.07258946 3.18639453 1.08373783 5.37500389 1.0625 7.5625 C1.05347656 8.76003906 1.04445313 9.95757812 1.03515625 11.19140625 C1.02355469 12.11824219 1.01195312 13.04507813 1 14 C-0.0209375 13.71125 -1.041875 13.4225 -2.09375 13.125 C-16.9186351 9.22672632 -33.4695828 7.45361324 -48.4375 11.625 C-55.46252662 14.29675215 -61.46401234 17.81163918 -66.3125 23.625 C-72.92130109 33.52899718 -73.57799443 43.51023432 -73.47045898 55.12939453 C-73.16908393 65.41472232 -71.39014247 73.58458809 -65.875 82.4375 C-60.92389815 88.94043975 -54.55257981 92.33586135 -46.875 94.8125 C-30.68338156 99.10668898 -14.9204415 96.27133796 1 92 C1 96.62 1 101.24 1 106 C-18.9653051 111.15957323 -40.18551571 112.79098447 -60 106 C-68.2810113 102.72134633 -75.33888649 96.64106895 -80.82421875 89.6875 C-89.03496241 77.11285983 -90.29399167 62.36861475 -90.1484375 47.76953125 C-89.66626404 35.52486304 -86.75672315 23.60847804 -79.375 13.625 C-71.69246812 4.74612639 -61.53973438 0.22720345 -50.37890625 -2.68359375 C-33.61075585 -6.13236227 -16.40608499 -4.27313302 0 0 Z",
  },
  {
    transform: "translate(494 72)",
    d: "M0 0 C2.86267567 -0.07325168 5.700719 -0.09238205 8.5625 -0.0625 C9.36880859 -0.05798828 10.17511719 -0.05347656 11.00585938 -0.04882812 C13.00393756 -0.03700518 15.00197783 -0.01906914 17 0 C24.08288706 15.67129563 30.91535319 31.43065008 37.54882812 47.29660034 C41.71637678 57.26295959 45.93765096 67.20299638 50.24609375 77.109375 C50.68450089 78.11847427 51.12290802 79.12757355 51.57460022 80.16725159 C53.72814604 85.12177399 55.88814318 90.07335122 58.05688477 95.02124023 C58.84020182 96.8200647 59.62333313 98.61897007 60.40625 100.41796875 C60.95344948 101.65743256 60.95344948 101.65743256 61.51170349 102.92193604 C61.841064 103.68141541 62.1704245 104.44089478 62.50976562 105.22338867 C62.94367615 106.21395515 62.94367615 106.21395515 63.38635254 107.22453308 C64 109 64 109 64 112 C58.39 112 52.78 112 47 112 C42.38 100.78 37.76 89.56 33 78 C20.79 77.67 8.58 77.34 -4 77 C-2.68 73.04 -1.36 69.08 0 65 C8.91 64.67 17.82 64.34 27 64 C24.91935842 58.8585376 22.83828065 53.71725613 20.75610352 48.57641602 C20.04881782 46.82977424 19.34178285 45.08303091 18.63500977 43.33618164 C17.61541583 40.81629726 16.59490216 38.296787 15.57421875 35.77734375 C15.26159592 35.00414291 14.94897308 34.23094208 14.62687683 33.43431091 C14.32679214 32.69407181 14.02670746 31.9538327 13.7175293 31.19116211 C13.43138763 30.48466522 13.14524597 29.77816833 12.85043335 29.05026245 C12.02623691 27.0632531 11.15492684 25.10245713 10.27661133 23.13891602 C9 20 9 20 9 17 C8.34 17 7.68 17 7 17 C6.64292969 18.14210938 6.28585937 19.28421875 5.91796875 20.4609375 C3.4061666 27.98317784 0.31026923 35.2870025 -2.6875 42.625 C-3.3469525 44.24512066 -4.00620983 45.86532078 -4.6652832 47.4855957 C-10.32103628 61.37867249 -16.01421926 75.25658395 -21.71948242 89.12939453 C-24.84837281 96.7392055 -27.9640434 104.35246374 -31 112 C-36.28 112 -41.56 112 -47 112 C-46.24531765 108.22658826 -45.52137149 105.55097618 -44.04492188 102.11010742 C-43.63879669 101.1570723 -43.23267151 100.20403717 -42.8142395 99.22212219 C-42.37022797 98.19362656 -41.92621643 97.16513092 -41.46875 96.10546875 C-41.00532196 95.02142258 -40.54189392 93.9373764 -40.06442261 92.82048035 C-38.54731511 89.2742656 -37.02363443 85.73091469 -35.5 82.1875 C-34.45342924 79.74386853 -33.40726946 77.30006635 -32.36181641 74.85595703 C-30.51266247 70.5339757 -28.66210573 66.21260134 -26.80951118 61.89209366 C-22.66877303 52.23477408 -18.55274114 42.56704505 -14.44555664 32.89541626 C-13.40396711 30.4431974 -12.36129942 27.99143965 -11.31835938 25.53979492 C-10.67832211 24.03436936 -10.03834573 22.52891792 -9.3984375 21.0234375 C-9.10100647 20.32408585 -8.80357544 19.62473419 -8.49713135 18.90419006 C-6.26891544 13.65620485 -4.08693791 8.39042368 -1.93212891 3.11181641 C-1 1 -1 1 0 0 Z",
  },
];

const TIMING: KeyframeAnimationOptions = {
  duration: 560,
  easing: "cubic-bezier(.45,0,.25,1)",
  fill: "forwards",
};

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

// Icons rest hidden (opacity 0) between plays; letters rest fully visible.
// We set opacity explicitly rather than removeProperty(), because there's no
// stylesheet rule here (unlike the original HTML's CSS classes) to fall back
// to — removeProperty would leave these elements stuck fully visible.
function resetElement(el: Element, restingOpacity: number) {
  el.getAnimations().forEach((a) => a.cancel());
  const style = (el as HTMLElement | SVGElement).style;
  style.removeProperty("transform");
  style.opacity = String(restingOpacity);
  style.removeProperty("filter");
}

function slide(
  el: Element,
  fromX: number,
  toX: number,
  opacityFrom = 1,
  opacityTo = 1,
  duration = 560
) {
  return el.animate(
    [
      { transform: `translateX(${fromX}px)`, opacity: opacityFrom },
      { transform: `translateX(${toX}px)`, opacity: opacityTo },
    ],
    { ...TIMING, duration }
  ).finished;
}

async function passThrough(el: Element, pause = 220, enter = 500, exit = 500) {
  await slide(el, -430, 0, 0, 1, enter);
  await sleep(pause);
  await slide(el, 0, 430, 1, 0, exit);
}

export type AticaAnimatedLogoProps = {
  className?: string;
};

function AticaAnimatedLogo({ className }: AticaAnimatedLogoProps) {
  const letterRefs = useRef<(SVGGElement | null)[]>([]);
  const hotelRef = useRef<SVGGElement>(null);
  const moneyRef = useRef<SVGGElement>(null);
  const graphRef = useRef<SVGGElement>(null);
  const playingRef = useRef(false);
  const lastTapRef = useRef(0);

  const play = async () => {
    if (playingRef.current) return;
    const letters = letterRefs.current.filter((el): el is SVGGElement => !!el);
    const hotel = hotelRef.current;
    const money = moneyRef.current;
    const graph = graphRef.current;
    if (!hotel || !money || !graph || letters.length !== LETTERS.length) return;

    playingRef.current = true;
    try {
      const icons = [hotel, money, graph];
      letters.forEach((el) => resetElement(el, 1));
      icons.forEach((el) => resetElement(el, 0));

      const prefersReducedMotion =
        typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (prefersReducedMotion) {
        letters.forEach((el) =>
          el.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 350 })
        );
        await sleep(400);
        return;
      }

      for (const letter of letters) {
        // Not awaited — letters stagger in while the next one starts. If a later
        // reset/cancel() aborts this animation mid-flight, .finished rejects with
        // AbortError; swallow it so it doesn't surface as an unhandled rejection.
        slide(letter, 0, 680, 1, 0, 620).catch(() => {});
        await sleep(105);
      }
      await sleep(340);

      await passThrough(hotel, 240, 500, 500);
      await sleep(60);
      await passThrough(money, 240, 500, 500);
      await sleep(60);
      await passThrough(graph, 320, 520, 520);

      letters.forEach((el) => {
        el.getAnimations().forEach((a) => a.cancel());
        el.style.opacity = "0";
      });

      for (const letter of letters) {
        slide(letter, -680, 0, 0, 1, 650).catch(() => {});
        await sleep(110);
      }

      await sleep(500);
      letters.forEach((el) => resetElement(el, 1));
      icons.forEach((el) => resetElement(el, 0));
    } catch {
      // AbortError from cancelled animations — fall through to reset playingRef.
    } finally {
      playingRef.current = false;
    }
  };

  // Mirrors onDoubleClick for keyboard users: native Enter/Space activation
  // fires on every single press, so without this a keyboard user would
  // trigger the easter egg on the first press rather than needing two in
  // quick succession like a mouse double-click.
  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    e.preventDefault();

    const now = Date.now();
    const isDoublePress = now - lastTapRef.current < 400;
    lastTapRef.current = now;
    if (isDoublePress) play();
  };

  return (
    <button
      type="button"
      onDoubleClick={play}
      onKeyDown={handleKeyDown}
      aria-label="Atica logo. Double-click or press Enter to play the sales-to-profit animation"
      title="Double-click me"
      className={`cursor-pointer border-0 bg-transparent p-0 ${
        className ?? ""
      }`}
    >
      <svg
        viewBox="0 0 600 260"
        role="img"
        aria-labelledby="aticaAnimatedLogoTitle"
        className="block h-full w-auto"
      >
        <title id="aticaAnimatedLogoTitle">Atica</title>

        <g>
          {LETTERS.map((letter, index) => (
            <g key={letter.transform} transform={letter.transform}>
              <g
                ref={(el) => {
                  letterRefs.current[index] = el;
                }}
                style={{ transformBox: "fill-box", transformOrigin: "center" }}
              >
                <path d={letter.d} fill="#FFFFFF" />
              </g>
            </g>
          ))}
        </g>

        <g transform="translate(247 79)">
          <g
            ref={hotelRef}
            style={{
              transformBox: "fill-box",
              transformOrigin: "center",
              opacity: 0,
            }}
          >
            <rect x="10" y="24" width="86" height="78" rx="10" fill="#f8fafc" />
            <rect x="34" y="0" width="38" height="26" rx="8" fill="#65e6a7" />
            <text
              x="53"
              y="13"
              fill="#0f5132"
              fontWeight={800}
              fontSize={16}
              fontFamily="Inter, sans-serif"
              textAnchor="middle"
              dominantBaseline="central"
            >
              H
            </text>

            <rect x="22" y="38" width="12" height="12" rx="2" fill="#94a3b8" />
            <rect x="47" y="38" width="12" height="12" rx="2" fill="#94a3b8" />
            <rect x="72" y="38" width="12" height="12" rx="2" fill="#94a3b8" />
            <rect x="22" y="58" width="12" height="12" rx="2" fill="#94a3b8" />
            <rect x="47" y="58" width="12" height="12" rx="2" fill="#94a3b8" />
            <rect x="72" y="58" width="12" height="12" rx="2" fill="#94a3b8" />

            <path d="M35 80 H71 L66 88 H40 Z" fill="#65e6a7" />
            <rect x="43" y="86" width="20" height="16" rx="4" fill="#0f5132" />
            <circle cx="59" cy="94" r="1.8" fill="#65e6a7" />

            <rect x="4" y="98" width="98" height="6" rx="3" fill="#65e6a7" />
          </g>
        </g>

        <g transform="translate(248 92)">
          <g
            ref={moneyRef}
            style={{
              transformBox: "fill-box",
              transformOrigin: "center",
              opacity: 0,
            }}
          >
            <rect width="104" height="72" rx="12" fill="#65e6a7" />
            <rect
              x="8"
              y="8"
              width="88"
              height="56"
              rx="9"
              fill="none"
              stroke="#0f5132"
              strokeWidth={4}
            />
            <circle cx="18" cy="18" r="4" fill="#0f5132" />
            <circle cx="86" cy="54" r="4" fill="#0f5132" />
            <text
              x="52"
              y="37"
              fill="#0f5132"
              fontWeight={800}
              fontSize={34}
              fontFamily="Inter, sans-serif"
              textAnchor="middle"
              dominantBaseline="central"
            >
              $
            </text>
          </g>
        </g>

        <g transform="translate(231 76)">
          <g
            ref={graphRef}
            style={{
              transformBox: "fill-box",
              transformOrigin: "center",
              opacity: 0,
            }}
          >
            <rect width="138" height="104" rx="14" fill="#f8fafc" />
            <path
              d="M24 22 V80 H116"
              fill="none"
              stroke="#94a3b8"
              strokeWidth={4}
              strokeLinecap="round"
            />
            <path
              d="M30 70 L52 58 L72 62 L95 38 L116 24"
              fill="none"
              stroke="#65e6a7"
              strokeWidth={7}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M108 21 L124 20 L120 36 Z" fill="#65e6a7" />
          </g>
        </g>
      </svg>
    </button>
  );
}

export default AticaAnimatedLogo;
